import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-achievement",
  "use": "icon-achievement-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-achievement\">\n<style type=\"text/css\">\n\t#icon-achievement .st0{enable-background:new    ;}\n</style>\n<path class=\"st0\" d=\"M100,16.3c-46.4,0-84.1,37.7-84.1,84.1c0,46.4,37.7,84.1,84.1,84.1s84.1-37.7,84.1-84.1\n\tC184.1,54,146.4,16.3,100,16.3z M100,173.5c-40.4,0-73.1-32.7-73.1-73.1c0-40.4,32.7-73.1,73.1-73.1s73.1,32.7,73.1,73.1\n\tC173.1,140.8,140.4,173.5,100,173.5z\" />\n<path d=\"M100,54.2c-19.8,0-40.8,4.4-59.5,11C46.5,106,68,143.5,100,168.3c32-25.4,53.5-62.3,59.5-103.1\n\tC140.8,58.6,119.8,54.2,100,54.2z M94.5,145.7c-17.6-16-30.3-37.5-35.3-61.2c-1.1-4.4,1.7-8.8,6.1-9.9c11.6-3.3,23.7-5.5,35.3-5.5\n\ts23.7,2.2,35.3,5.5c4.4,1.1,6.6,5.5,6.1,9.9c-5,23.7-17.6,45.2-35.3,61.2C102.8,148.4,97.8,148.4,94.5,145.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/achievement.svg
// module id = SOLA
// module chunks = 3